function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  border: 1px solid var(--theme-border, #e5e7eb);\n  /* border-radius: 0.5rem; */ // 둥근 모서리 제거\n  padding: 1rem;\n  background-color: var(--my-card-background, white); // 테마 변수 사용\n  cursor: pointer; // 항상 포인터 커서 사용\n  transition: box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out;\n\n  // &:hover 는 clickable 여부와 상관없이 적용되도록 수정\n  &:hover {\n    box-shadow: var(--theme-shadow-hover, 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1)); // 테마 변수 사용 (없으면 기본값)\n    border-color: var(--theme-border-light, #d1d5db);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  font-size: 1.125rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  color: var(--theme-text, #111827); // 테마 변수 사용\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  font-size: 0.875rem;\n  color: var(--theme-text-secondary, #6b7280); // 테마 변수 사용\n  // 필요시 line-clamp 등 추가 스타일 적용\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: 0.75rem; // 12px\n  margin-top: 1rem; // 위 요소들과 간격\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  font-size: 0.875rem; // 14px\n  color: var(--theme-text-muted, #6b7280);\n\n  svg {\n    width: 1rem; // 16px\n    height: 1rem; // 16px\n    margin-right: 0.25rem; // 4px\n    color: var(--theme-icon-muted, #9ca3af);\n  }\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router';
import { useDisclosure } from '@heroui/react';
// Lucide React 직접 import - Vite 번들링 최적화 및 초기화 순서 문제 해결
import { Users } from 'lucide-react';
import { CheckCircle } from 'lucide-react';
import { Flag } from 'lucide-react';
import { SocialHeader } from '@edusense/shared-ui-layout'; // layout-ui에서 import
import { ReportDialog } from '@edusense/shared-ui-components';
// --- Styled Components --- (CourseCard 참고하여 정의)
var CardContainer = styled.div(_templateObject());
var Title = styled.h3(_templateObject1());
var Description = styled.p(_templateObject2());
// --- 추가: 통계 정보 표시용 스타일 --- 
var StatsContainer = styled.div(_templateObject3());
var StatItem = styled.div(_templateObject4());
// -------------------------
var RoadmapCard = function(param) {
    var roadmap = param.roadmap, currentUserId = param.currentUserId, _param_isCreator = param.isCreator, isCreator = _param_isCreator === void 0 ? false : _param_isCreator, onClick = param.onClick, onReport = param.onReport, _param_className = param.className, className = _param_className === void 0 ? '' : _param_className;
    var _creatorData_basicInfo, _creatorData_basicInfo1, _creatorData_basicInfo2, _creatorData_basicInfo3, _creatorData_basicInfo4;
    var navigate = useNavigate(); // useNavigate 훅 사용
    var _useDisclosure = useDisclosure(), isReportModalOpen = _useDisclosure.isOpen, onReportModalOpen = _useDisclosure.onOpen, onReportModalClose = _useDisclosure.onClose;
    var handleCardClick = function() {
        // onClick prop이 있으면 호출, 없으면 상세 페이지로 이동
        if (onClick) {
            onClick(roadmap.id);
        } else {
            navigate("/learn/roadmap/".concat(roadmap.id));
        }
    };
    // 신고 제출 핸들러
    var handleReportSubmit = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(data) {
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!onReport) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            onReport(roadmap.id, data)
                        ];
                    case 1:
                        _state.sent();
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleReportSubmit(data) {
            return _ref.apply(this, arguments);
        };
    }();
    // creator가 이미 flat 구조이므로 직접 매핑 (useRoadmapData에서 변환됨)
    // 또는 basicInfo 중첩 구조도 지원 (RoadmapDetailPage 등에서 직접 API 응답 사용 시)
    var creatorData = roadmap.creator;
    var _creatorData_verified;
    var author = creatorData ? {
        id: String(creatorData.id || ((_creatorData_basicInfo = creatorData.basicInfo) === null || _creatorData_basicInfo === void 0 ? void 0 : _creatorData_basicInfo.id) || '0'),
        username: creatorData.username || ((_creatorData_basicInfo1 = creatorData.basicInfo) === null || _creatorData_basicInfo1 === void 0 ? void 0 : _creatorData_basicInfo1.username) || '',
        displayName: creatorData.displayName || ((_creatorData_basicInfo2 = creatorData.basicInfo) === null || _creatorData_basicInfo2 === void 0 ? void 0 : _creatorData_basicInfo2.displayName) || '',
        name: creatorData.displayName || ((_creatorData_basicInfo3 = creatorData.basicInfo) === null || _creatorData_basicInfo3 === void 0 ? void 0 : _creatorData_basicInfo3.displayName) || '',
        profileImageUrl: creatorData.profileImageUrl || ((_creatorData_basicInfo4 = creatorData.basicInfo) === null || _creatorData_basicInfo4 === void 0 ? void 0 : _creatorData_basicInfo4.profileImageUrl),
        verified: (_creatorData_verified = creatorData.verified) !== null && _creatorData_verified !== void 0 ? _creatorData_verified : false
    } : null;
    // 액션 메뉴 아이템 구성
    var actionMenuItems = useMemo(function() {
        var items = [];
        // 신고 메뉴 추가 (모든 사용자, 작성자 본인 로드맵 제외)
        if (onReport && !isCreator) {
            items.push({
                label: '신고',
                icon: /*#__PURE__*/ React.createElement(Flag, {
                    className: "w-4 h-4"
                }),
                onClick: onReportModalOpen,
                variant: 'danger'
            });
        }
        return items.length > 0 ? items : undefined;
    }, [
        onReport,
        isCreator,
        onReportModalOpen
    ]);
    var _author_verified;
    return /*#__PURE__*/ React.createElement(CardContainer, {
        className: "roadmap-card ".concat(className),
        onClick: handleCardClick
    }, author && /*#__PURE__*/ React.createElement(SocialHeader, {
        author: {
            id: author.id,
            name: author.displayName,
            username: author.username,
            profileImageUrl: author.profileImageUrl,
            verified: (_author_verified = author.verified) !== null && _author_verified !== void 0 ? _author_verified : false
        },
        createdAt: roadmap.createdAt ? new Date(roadmap.createdAt) : undefined,
        size: "sm",
        showTimestamp: true,
        showActions: !!actionMenuItems,
        variant: "default",
        isRetweet: false,
        showThreadLineTop: false,
        showThreadLineBottom: false,
        actions: actionMenuItems
    }), /*#__PURE__*/ React.createElement("div", {
        style: {
            marginTop: author ? '0.75rem' : '0'
        }
    }, /*#__PURE__*/ React.createElement(Title, null, roadmap.title), roadmap.description && /*#__PURE__*/ React.createElement(Description, null, roadmap.description)), roadmap.subscriptionCount !== undefined && roadmap.subscriptionCount >= 0 || roadmap.isSubscribed ? /*#__PURE__*/ React.createElement(StatsContainer, null, roadmap.subscriptionCount !== undefined && roadmap.subscriptionCount >= 0 && /*#__PURE__*/ React.createElement(StatItem, {
        title: "구독자 ".concat(roadmap.subscriptionCount, "명")
    }, /*#__PURE__*/ React.createElement(Users, null), roadmap.subscriptionCount), roadmap.isSubscribed && /*#__PURE__*/ React.createElement(StatItem, {
        title: "구독 중인 로드맵입니다"
    }, /*#__PURE__*/ React.createElement(CheckCircle, {
        style: {
            color: 'var(--theme-success, green)'
        }
    }), " ", /*#__PURE__*/ React.createElement("span", null, "구독중"))) : null, onReport && /*#__PURE__*/ React.createElement(ReportDialog, {
        isOpen: isReportModalOpen,
        onClose: onReportModalClose,
        targetType: "roadmap",
        targetId: roadmap.id,
        targetTitle: roadmap.title,
        onSubmit: handleReportSubmit
    }));
};
export default RoadmapCard;
